import React from 'react';
import type { GetServerSideProps, GetServerSidePropsContext } from 'next';
import Head from 'next/head';
import Link from 'next/link';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ForgotPasswordForm } from '@/components/auth/ForgotPasswordForm';
import { AuthShell } from '@/components/auth/AuthShell';
import Layout from '@/components/Layout';
import { useTranslation } from '@/hooks/useTranslation';
import { useRedirectIfAuthenticated } from '@/hooks/useRedirectIfAuthenticated';

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  useRedirectIfAuthenticated();

  return (
    <>
      <Head>
        <title>{t('auth.forgotPasswordPage.metaTitle')}</title>
        <meta
          name="description"
          content={t('auth.forgotPasswordPage.metaDescription')}
        />
      </Head>

      <Layout>
        <AuthShell
          title={t('auth.forgotPasswordPage.heading')}
          description={t('auth.forgotPasswordPage.description')}
          footer={
            <Link href="/auth/signin" className="link">
              {t('auth.forgotPasswordPage.orSignIn')}
            </Link>
          }
        >
          <ForgotPasswordForm />
        </AuthShell>
      </Layout>
    </>
  );
}

// Without server-side translations this page SSRs raw i18n keys and then
// fails hydration when the client swaps in the real strings.
export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  return {
    props: {
      ...(await serverSideTranslations(context.locale ?? 'en', ['common'])),
    },
  };
};
